/* Maison Lamora — web configurator (port of the iOS Configure screen). */
(function () {
  var D, L;
  var PRESETS = {
    'wing|honey': ['feather', ['LMR-FEA-002', 'LMR-FEA-001']], 'wing|blacktint': ['feather', ['LMR-FEA-010', 'LMR-FEA-013']],
    'wing|transparent': ['feather', ['LMR-FEA-003']], 'wing|tint': ['feather', ['LMR-FEA-009', 'LMR-FEA-018']],
    'blownleaf|gold': ['frozen', ['LMR-FRZ-002', 'LMR-FRZ-001']], 'blownleaf|transparent': ['frozen', ['LMR-FRZ-001', 'LMR-FRZ-005']],
    'blownleaf|blue': ['frozen', ['LMR-FRZ-008', 'LMR-FRZ-003']], 'leaf|honey': ['leaf', ['LMR-LFV-002', 'LMR-LFV-001']],
    'bloom|transparent': ['flower', ['LMR-FLW-001']]
  };


  /* Build the full element list: one entry per family, every catalogue piece as a tone. */
  var FAM_META = {
    'Feather': ['Plume-form strand', 22], 'Leaf': ['Organic glass leaf', 20],
    'Quarter Twist': ['Spiral twist strand', 20], 'Full Twist': ['Full-length spiral strand', 24],
    'Twist': ['Twisted glass strand', 20], 'Wave': ['Flowing wave form', 18],
    'Flower': ['Glass blossom', 18], 'Frozen': ['Organic ice-splash form', 20],
    'Butterfly': ['Delicate glass butterfly', 14], 'Blown': ['Blown sphere and hollow', 16],
    'Stone': ['Solid cast stone form', 12], 'Other': ['Reserve forms', 16]
  };
  function buildElements(D) {
    if (D._elements) return D._elements;
    var known = {};
    (D.elements || []).forEach(function (e) {
      e.tones.forEach(function (t) { known[t.sku] = t; });
    });
    var byFam = {};
    (D.library || []).forEach(function (p) { (byFam[p.family] = byFam[p.family] || []).push(p); });
    var out = (D.families || []).map(function (f) { return f[0]; })
      .filter(function (f) { return byFam[f]; })
      .map(function (fam) {
        var meta = FAM_META[fam] || ['Glass element', 18];
        return {
          id: fam.toLowerCase().replace(/[^a-z]+/g, ''), label: fam, meta: meta[0], pieceCm: meta[1],
          tones: byFam[fam].map(function (p) {
            var k = known[p.sku];
            return { id: p.sku, label: k && k.label ? k.label + ' · ' + p.name.replace(/\D+/g, '') : p.name, color: (k && k.color) || '#d9c9ae', sku: p.sku };
          })
        };
      });
    D._elements = out.length ? out : D.elements;
    return D._elements;
  }

  function $(root, sel) { return root.querySelector(sel); }
  function el(tag, cls, html) { var e = document.createElement(tag); if (cls) e.className = cls; if (html != null) e.innerHTML = html; return e; }
  function esc(s) { return String(s).replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }

  function Configurator(root) {
    D = window.LAMORA_DATA; L = window.LAMORA;
    D.elements = buildElements(D);
    this.root = root;
    this.state = {
      room: 'dining', design: 'randomheights', element: 'feather', tones: ['LMR-FEA-001'], mixed: false,
      width: 180, depth: 80, height: 110, pieces: 34, scale: 100, dropStart: 15, dropEnd: 95,
      pieceRotate: 0, pieceJitter: 100,
      spots: true, spotPattern: 'rectangle', spotCount: 18, spotColor: 'white', spotSpread: 100, name: ''
    };
    this.fromUrl();
    this.canvas = $(root, '[data-cfg-canvas]');
    this.composer = new window.LamoraComposer(this.canvas, { yaw: -0.55, pitch: 0.3 });
    this.composer.enableOrbit(this.canvas);
    this.build();
    this.bind();
    this.apply();
    this.composer.autoRotate(true);
    var self = this;
    window.addEventListener('resize', function () { self.composer.render(); });
  }

  Configurator.prototype.elementDef = function (id) { return D.elements.find(function (e) { return e.id === (id || this.state.element); }, this) || D.elements[0]; };
  Configurator.prototype.toneDefs = function () {
    var e = this.elementDef();
    return this.state.tones.map(function (t) { return e.tones.find(function (x) { return x.id === t; }); }).filter(Boolean);
  };

  Configurator.prototype.fromUrl = function () {
    var q = new URLSearchParams(location.search), s = this.state;
    var preset = q.get('preset');
    if (preset) {
      var inst = D.installations.find(function (i) { return i.id === preset || i.handle === preset; });
      if (inst) {
        var p = PRESETS[inst.element + '|' + inst.tone] || ['feather1', ['dual']];
        Object.assign(s, { room: inst.room === 'other' ? 'living' : inst.room, design: inst.composition, element: p[0], tones: p[1], mixed: p[1].length > 1,
          width: inst.width, depth: inst.depth, height: inst.height, pieces: inst.pieces, name: 'Based on ' + inst.name,
          dropStart: inst.composition === 'cascadespiral' || inst.composition === 'waterfall' ? 4 : 20, dropEnd: inst.composition === 'ring' ? 55 : 95 });
      }
    }
    var num = function (k, key, lo, hi) { var v = parseFloat(q.get(k)); if (!isNaN(v)) s[key] = Math.max(lo, Math.min(hi, v)); };
    if (q.get('d')) s.design = q.get('d');
    if (q.get('r')) s.room = q.get('r');
    if (q.get('e') && D.elements.some(function (e) { return e.id === q.get('e'); })) s.element = q.get('e');
    if (q.get('t')) { s.tones = q.get('t').split(',').slice(0, 3); s.mixed = s.tones.length > 1; }
    num('w', 'width', 40, 500); num('dp', 'depth', 40, 500); num('h', 'height', 40, 800); num('n', 'pieces', 6, 150);
    num('pr', 'pieceRotate', -90, 90); num('pj', 'pieceJitter', 0, 200);
    num('s', 'scale', 40, 200); num('a', 'dropStart', 0, 100); num('b', 'dropEnd', 0, 100);
    if (q.get('sp') === '0') s.spots = false;
    if (q.get('spp')) s.spotPattern = q.get('spp');
    if (q.get('spc')) s.spotColor = q.get('spc');
    num('spn', 'spotCount', 1, 60);
    var piece = q.get('piece');
    if (piece) {
      D.elements.forEach(function (e) { e.tones.forEach(function (t) { if (t.sku === piece) { s.element = e.id; s.tones = [t.id]; s.mixed = false; } }); });
    }
    if (!D.elements.some(function (x) { return x.id === s.element; })) { s.element = D.elements[0].id; s.tones = []; }
    var e = this.elementDef();
    s.tones = s.tones.filter(function (t) { return e.tones.some(function (x) { return x.id === t; }); });
    if (!s.tones.length) s.tones = [e.tones[0].id];
  };

  Configurator.prototype.toUrl = function () {
    var s = this.state;
    var q = new URLSearchParams({ r: s.room, d: s.design, e: s.element, t: s.tones.join(','), w: Math.round(s.width), dp: Math.round(s.depth), h: Math.round(s.height), n: Math.round(s.pieces), s: Math.round(s.scale), a: Math.round(s.dropStart), b: Math.round(s.dropEnd), pr: Math.round(s.pieceRotate), pj: Math.round(s.pieceJitter) });
    if (!s.spots) q.set('sp', '0');
    q.set('spp', s.spotPattern); q.set('spc', s.spotColor); q.set('spn', Math.round(s.spotCount));
    return location.pathname + '?' + q.toString();
  };

  /* ---------- UI construction ---------- */
  Configurator.prototype.build = function () {
    var self = this, s = this.state;

    var rooms = $(this.root, '[data-cfg-rooms]');
    Object.keys(D.rooms).forEach(function (k) {
      var b = el('button', 'chip', esc(D.rooms[k][0])); b.type = 'button'; b.dataset.room = k;
      b.addEventListener('click', function () {
        var r = D.rooms[k];
        Object.assign(s, { room: k, design: r[1], width: r[2], depth: r[3], height: r[4] });
        if (r[1] === 'cascadespiral') { s.dropStart = 4; s.dropEnd = 96; s.pieces = Math.max(s.pieces, 50); }
        else if (r[1] === 'ring') { s.dropStart = 35; s.dropEnd = 60; }
        else { s.dropStart = 15; s.dropEnd = 95; }
        self.apply();
      });
      rooms.appendChild(b);
    });

    var comps = $(this.root, '[data-cfg-comps]');
    D.compositions.forEach(function (c) {
      var b = el('button', 'chip', esc(c[1])); b.type = 'button'; b.dataset.design = c[0];
      b.addEventListener('click', function () { s.design = c[0]; self.apply(); });
      comps.appendChild(b);
    });

    var elems = $(this.root, '[data-cfg-elements]');
    D.elements.forEach(function (e) {
      var b = el('button', 'tile');
      b.type = 'button'; b.dataset.element = e.id;
      b.innerHTML = '<span class="tile__img"><img alt="" loading="lazy" src="' + esc(L.pieceImage(e.tones[0].sku, 360)) + '" onerror="this.remove()"></span><span class="tile__label">' + esc(e.label) + '</span><span class="tile__meta">' + esc(e.meta) + '</span>';
      b.addEventListener('click', function () {
        s.element = e.id; s.tones = [e.tones[0].id]; s.mixed = false; self.buildTones(); self.apply();
      });
      elems.appendChild(b);
    });
    this.buildTones();

    this.sliders = {};
    this.root.querySelectorAll('[data-cfg-range]').forEach(function (input) {
      var key = input.dataset.cfgRange;
      self.sliders[key] = input;
      input.addEventListener('input', function () {
        s[key] = parseFloat(input.value);
        if (key === 'dropStart' && s.dropStart > s.dropEnd) s.dropEnd = s.dropStart;
        if (key === 'dropEnd' && s.dropEnd < s.dropStart) s.dropStart = s.dropEnd;
        self.apply(true);
      });
    });

    this.root.querySelectorAll('[data-cfg-pattern]').forEach(function (b) {
      b.addEventListener('click', function () { s.spotPattern = b.dataset.cfgPattern; self.apply(); });
    });
    this.root.querySelectorAll('[data-cfg-spotcolor]').forEach(function (b) {
      b.addEventListener('click', function () { s.spotColor = b.dataset.cfgSpotcolor; self.apply(); });
    });
    var yaw = $(this.root, '[data-cfg-yaw]');
    if (yaw) yaw.addEventListener('input', function () {
      self.composer.autoRotate(false); self._spinning = false;
      var btn = $(self.root, '[data-cfg-action="spin"]'); if (btn) btn.classList.remove('is-active');
      self.composer.cfg.yaw = parseFloat(yaw.value) * Math.PI / 180;
      self.composer.render();
      if (self.viewer && self.activeTab === 'room') self.viewer.refresh();
    });
    this.root.querySelectorAll('[data-cfg-turn]').forEach(function (b) {
      b.addEventListener('click', function () {
        self.composer.autoRotate(false); self._spinning = false;
        self.composer.cfg.yaw += parseFloat(b.dataset.cfgTurn) * Math.PI / 180;
        if (yaw) yaw.value = Math.round(self.composer.cfg.yaw * 180 / Math.PI);
        self.composer.render();
      });
    });

    var mix = $(this.root, '[data-cfg-mixed]');
    if (mix) mix.addEventListener('change', function () {
      s.mixed = mix.checked;
      if (!s.mixed) s.tones = s.tones.slice(0, 1);
      self.apply();
    });
    var spots = $(this.root, '[data-cfg-spots]');
    if (spots) spots.addEventListener('change', function () { s.spots = spots.checked; self.apply(); });
  };

  Configurator.prototype.buildTones = function () {
    var self = this, s = this.state, e = this.elementDef();
    var wrap = $(this.root, '[data-cfg-tones]');
    wrap.innerHTML = '';
    e.tones.forEach(function (t) {
      var b = el('button', 'tile tile--tone');
      b.type = 'button'; b.dataset.tone = t.id;
      b.innerHTML = '<span class="tile__img" style="--swatch:' + esc(t.color) + '"><img alt="" loading="lazy" src="' + esc(L.pieceImage(t.sku, 360)) + '" onerror="this.remove()"></span><span class="tile__label">' + esc(t.label) + '</span><span class="tile__meta">' + esc(t.sku) + '</span>';
      b.addEventListener('click', function () {
        if (s.mixed) {
          var i = s.tones.indexOf(t.id);
          if (i > -1) { if (s.tones.length > 1) s.tones.splice(i, 1); }
          else { s.tones.push(t.id); if (s.tones.length > 3) s.tones.shift(); }
        } else s.tones = [t.id];
        self.apply();
      });
      wrap.appendChild(b);
    });
    var mixRow = $(this.root, '[data-cfg-mixrow]');
    if (mixRow) mixRow.hidden = e.tones.length < 2;
  };

  /* ---------- apply state ---------- */
  Configurator.prototype.apply = function (fromSlider) {
    var s = this.state, root = this.root, self = this;
    root.querySelectorAll('[data-room]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.room === s.room); });
    root.querySelectorAll('[data-design]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.design === s.design); });
    root.querySelectorAll('[data-element]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.element === s.element); });
    root.querySelectorAll('[data-tone]').forEach(function (b) { b.classList.toggle('is-active', s.tones.indexOf(b.dataset.tone) > -1); });
    root.querySelectorAll('[data-cfg-pattern]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.cfgPattern === s.spotPattern); });
    root.querySelectorAll('[data-cfg-spotcolor]').forEach(function (b) { b.classList.toggle('is-active', b.dataset.cfgSpotcolor === s.spotColor); });
    var spotBox = root.querySelector('[data-cfg-spotbox]'); if (spotBox) spotBox.hidden = !s.spots;
    var mix = $(root, '[data-cfg-mixed]'); if (mix) mix.checked = s.mixed;
    var spots = $(root, '[data-cfg-spots]'); if (spots) spots.checked = s.spots;
    Object.keys(this.sliders).forEach(function (k) {
      var inp = self.sliders[k];
      if (!fromSlider || document.activeElement !== inp) inp.value = s[k];
      var out = root.querySelector('[data-cfg-out="' + k + '"]');
      if (out) out.textContent = Math.round(s[k]) + (inp.dataset.unit || '');
    });
    var spiral = $(root, '[data-cfg-only="cascadespiral"]');
    if (spiral) spiral.hidden = s.design !== 'cascadespiral';

    var tones = this.toneDefs();
    this.composer.set({
      pieceCm: this.elementDef().pieceCm || 22,
      design: s.design, pieces: s.pieces, width: s.width, depth: s.depth, height: s.height,
      scale: s.scale, dropStart: s.dropStart, dropEnd: s.dropEnd,
      pieceRotate: s.pieceRotate, pieceJitter: s.pieceJitter,
      spots: s.spots, spotPattern: s.spotPattern, spotCount: s.spotCount, spotColor: s.spotColor, spotSpread: s.spotSpread,
      sprites: tones.map(function (t) { return t.sku; }),
      colors: tones.map(function (t) { return t.color; })
    });

    var cap = $(root, '[data-cfg-caption]');
    if (cap) cap.textContent = this.label('design') + '  ·  ' + this.elementDef().label + '  ·  ' + tones.map(function (t) { return t.label; }).join(' + ') + '  ·  ' + Math.round(s.width) + ' × ' + Math.round(s.depth) + ' × ' + Math.round(s.height) + ' cm';
    this.renderSummary();
    clearTimeout(this._urlT);
    this._urlT = setTimeout(function () { try { history.replaceState({}, '', self.toUrl()); } catch (e) {} }, 300);
    if (this.viewer && this.activeTab === 'room') {
      clearTimeout(this._roomT);
      this._roomT = setTimeout(function () { self.viewer.state.manualScale = false; self.viewer.refresh(); }, 120);
    }
  };

  Configurator.prototype.label = function (k) {
    var s = this.state;
    if (k === 'design') { var c = D.compositions.find(function (c) { return c[0] === s.design; }); return c ? c[1] : s.design; }
    if (k === 'room') return (D.rooms[s.room] || ['Other'])[0];
    return '';
  };

  Configurator.prototype.specs = function () {
    var s = this.state, e = this.elementDef();
    return [
      ['Room', this.label('room')],
      ['Composition', this.label('design')],
      ['Element', e.label + ' \u00b7 ' + e.meta],
      ['Glass tone', this.toneDefs().map(function (t) { return t.label + ' (' + t.sku + ')'; }).join(', ')],
      ['Dimensions', Math.round(s.width) + ' W × ' + Math.round(s.depth) + ' D × ' + Math.round(s.height) + ' H cm'],
      ['Density', (function (n) {
        if (n < 24) return 'Sparse';
        if (n < 55) return 'Balanced';
        if (n < 95) return 'Full';
        return 'Dense';
      })(s.pieces)],
      ['Piece orientation', (Math.round(s.pieceRotate) === 0 ? 'Natural' : (s.pieceRotate > 0 ? 'Turned right ' : 'Turned left ') + Math.abs(Math.round(s.pieceRotate)) + '\u00b0') + ' \u00b7 ' + (s.pieceJitter < 40 ? 'aligned' : s.pieceJitter > 130 ? 'scattered' : 'natural spread')],
      ['Element size', Math.round(s.scale) + '%'],
      ['Drop variation', Math.round(s.dropStart) + '% to ' + Math.round(s.dropEnd) + '%'],
      ['Ceiling spotlights', s.spots ? Math.round(s.spotCount) + ' fixtures · ' + s.spotPattern + ' · ' + s.spotColor : 'None']
    ];
  };

  Configurator.prototype.renderSummary = function () {
    var t = $(this.root, '[data-cfg-specs]');
    if (!t) return;
    t.innerHTML = this.specs().map(function (r) { return '<dt>' + esc(r[0]) + '</dt><dd>' + esc(r[1]) + '</dd>'; }).join('');
  };

  Configurator.prototype.thumb = function () {
    try {
      var off = document.createElement('canvas');
      var info = this.composer.draw(off, off.getContext('2d'), { width: 360, height: 360, dpr: 1, pad: 0.06 });
      var bg = document.createElement('canvas'); bg.width = 360; bg.height = 360;
      var g = bg.getContext('2d'); g.fillStyle = '#141109'; g.fillRect(0, 0, 360, 360); g.drawImage(off, 0, 0);
      return bg.toDataURL('image/jpeg', 0.7);
    } catch (e) { return ''; }
  };

  Configurator.prototype.addToEnquiry = function (go) {
    var s = this.state;
    var title = (s.name || 'My Lamora design') + ' \u00b7 ' + this.label('design');
    var detail = this.specs().slice(1).map(function (r) { return r[0] + ': ' + r[1]; }).join(' · ');
    var id = 'design-' + [s.design, s.element, s.tones.join('+'), Math.round(s.width), Math.round(s.depth), Math.round(s.height), Math.round(s.pieces)].join('-');
    L.enquiry.add({ id: id, type: 'Design', title: title, detail: detail, image: this.thumb(), link: this.toUrl() }, !go);
    if (go) location.href = L.pages.quote;
  };

  /* ---------- tabs, actions ---------- */
  Configurator.prototype.bind = function () {
    var self = this, root = this.root;
    root.querySelectorAll('[data-cfg-tab]').forEach(function (t) {
      t.addEventListener('click', function () { self.showTab(t.dataset.cfgTab); });
    });
    root.addEventListener('click', function (e) {
      var a = e.target.closest('[data-cfg-action]');
      if (!a) return;
      var act = a.dataset.cfgAction;
      if (act === 'quote') self.addToEnquiry(true);
      if (act === 'enquiry') self.addToEnquiry(false);
      if (act === 'spin') { self._spinning = !self._spinning; self.composer.autoRotate(self._spinning); a.classList.toggle('is-active', self._spinning); }
      if (act === 'reset') { location.href = location.pathname; }
      if (act === 'share') {
        var url = location.origin + self.toUrl();
        var done = function () { a.querySelector('[data-label]').textContent = 'Link copied'; setTimeout(function () { a.querySelector('[data-label]').textContent = 'Copy link'; }, 2000); };
        if (navigator.share) navigator.share({ title: 'My Lamora design', url: url }).catch(function () {});
        else if (navigator.clipboard) navigator.clipboard.writeText(url).then(done, function () {});
      }
      if (act === 'save') {
        var saved = L.store.load('lamora-designs', []);
        saved.unshift({ url: self.toUrl(), when: Date.now(), title: self.label('design') + ' · ' + self.elementDef().label });
        L.store.save('lamora-designs', saved.slice(0, 12));
        a.querySelector('[data-label]').textContent = 'Saved on this device';
        self.renderSaved();
      }
      if (act === 'advisor') {
        var msg = 'Hello Maison Lamora, I designed this piece and would like advice: ' + location.origin + self.toUrl();
        if (L.whatsapp) window.open('https://wa.me/' + L.whatsapp + '?text=' + encodeURIComponent(msg), '_blank', 'noopener');
        else self.addToEnquiry(true);
      }
    });
    this._spinning = true;
    this.renderSaved();
  };

  Configurator.prototype.renderSaved = function () {
    var wrap = $(this.root, '[data-cfg-saved]');
    if (!wrap) return;
    var saved = L.store.load('lamora-designs', []);
    wrap.hidden = !saved.length;
    var list = wrap.querySelector('ul');
    list.innerHTML = saved.map(function (d) {
      return '<li><a href="' + esc(d.url) + '">' + esc(d.title) + '</a> <span class="fine">' + new Date(d.when).toLocaleDateString() + '</span></li>';
    }).join('');
  };

  Configurator.prototype.showTab = function (name) {
    var self = this;
    this.activeTab = name;
    this.root.querySelectorAll('[data-cfg-tab]').forEach(function (t) { var on = t.dataset.cfgTab === name; t.classList.toggle('is-active', on); t.setAttribute('aria-selected', on); });
    this.root.querySelectorAll('[data-cfg-panel]').forEach(function (p) { p.hidden = p.dataset.cfgPanel !== name; });
    if (name === 'design') { this.composer.render(); if (this._spinning) this.composer.autoRotate(true); }
    else this.composer.autoRotate(false);
    if (name === 'room') {
      if (!this.viewer) {
        var rooms = [];
        try { rooms = JSON.parse($(this.root, '[data-cfg-rooms-json]').textContent).filter(Boolean); } catch (e) {}
        this.viewer = new window.LamoraRoomViewer($(this.root, '[data-room-viewer]'), {
          rooms: rooms,
          onRotate: function (deg) {
            self.composer.autoRotate(false); self._spinning = false;
            self.composer.cfg.yaw = deg * Math.PI / 180;
            self.composer.render();
            self.viewer.refresh();
          },
          getChandelier: function (o) {
            var snap = self.composer.snapshot(1400, Math.round(1400 * Math.max(0.5, Math.min(2.2, (self.state.height + 40) / Math.max(self.state.width, 60)))));
            return { canvas: snap.canvas, pxPerCm: snap.pxPerCm, widthCm: self.state.width };
          }
        });
      } else { this.viewer.state.manualScale = false; this.viewer.refresh(); }
    }
  };

  function init() {
    document.querySelectorAll('[data-configurator]').forEach(function (r) {
      if (r.dataset.ready) return; r.dataset.ready = '1';
      try { new Configurator(r); } catch (e) { console.error('[Lamora] configurator', e); }
    });
  }
  if (document.readyState !== 'loading') init(); else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
